window.addEventListener("load", function () {
    // interact with the alert dialog when active
    var checkboxes = {
       // 'requestinfocheckbox': 'form_06158b5e-b8dc-4d17-b4b1-53b82e7e2b5f_1',
        'infosessioncheckbox': 'form_e3d340c3-146b-48ab-91d0-c943f953b90f_1'
    }

    var formel = document.getElementById('slate-buttons')
    if( ! formel ){
        return;
    } 
    var formid = formel.dataset.formid;
    
    // check if there is a class with the form id
    if( ! formid ) {
        let clbid = [... document.getElementById('slate-buttons').classList].find((i) => i.includes('buttonid-'))
        if ( clbid ){
            formid = clbid.replace('buttonid-', '') 
        }
    }

    var requestinfo = document.getElementById('slate-request');
    var infosession = document.getElementById('slate-infosession');


    var formscriptloaded = false;
    var formloaded = false;
    var formselect = false;

    var modal = document.createElement("dialog");
    modal.classList.add('slate');

    var headerHolder = document.createElement("div");
    headerHolder.classList.add('slate-header');
    modal.appendChild(headerHolder);

    var headertext = document.createElement("h2");
    headerHolder.appendChild(headertext);

    var close = document.createElement('button');
    close.classList.add('slate-close');
    close.innerHTML = '×';
    close.setAttribute('title', 'Close');
    headerHolder.appendChild(close);

    var modalbody = document.createElement('div');
    modalbody.classList.add('slate-body');

    var formholder = document.createElement('div');
    formholder.id = 'form_' + formid;
    formholder.innerText = "Loading...";
    modalbody.appendChild(formholder);
    modal.appendChild(modalbody);



    document.body.appendChild(modal);
    if (window.HTMLDialogElement === undefined) {
        window.scriptLoader(scriptBasePath + 'dialog-polyfill.js', () => {
            // only activate the modals if they're on the page
            dialogPolyfill.registerDialog(modal);
        });
    }
    

    // we need to watch the for the form so we can manipulate it. 

    // Callback function to execute when mutations are observed
    var callback = function (mutationsList, observer) {
        formloaded = true;
        if (formselect) {
            selectcheckbox(formselect);
            formselect = false;
        }
        observer.disconnect();
    };

    // Create an observer instance linked to the callback function
    var observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(formholder, { childList: true });

    function loadform() {
        if (formscriptloaded) return;

        // create the slate script to add the form
        var script = document.createElement('script');
        script.async = 1;
        script.src = 'https://apply.monmouth.edu/register/?id=' + formid + '&output=embed&div=form_' + formid + '' + ((location.search.length > 1) ? '&' + location.search.substring(1) : '');
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(script, s);

        formscriptloaded = true;
    }

    function selectcheckbox(checkbox) {
        if (formloaded) {
            Object.values(checkboxes).forEach(function (chx) {
                if (document.getElementById(chx).checked) {
                    jQuery('#' + chx).trigger('click');
                }
            });
            if (!checkbox) return;
            jQuery('#' + checkbox).trigger('click');
        } else {
            formselect = checkbox;
        }
    }

    requestinfo.addEventListener('click', function () {
        headertext.innerText = "Request Information";
        loadform();
        if (!('showModal' in modal)) {
            modal.show();
        } else {
            modal.showModal();
        }
        selectcheckbox();
    });

    infosession.addEventListener('click', function () {
        headertext.innerText = "Attend an Upcoming Event";
        loadform();
        if (!('showModal' in modal)) {
            modal.show();
        } else {
            modal.showModal();
        }
        selectcheckbox(checkboxes.infosessioncheckbox);
    });

    close.addEventListener('click', function () {
        modal.close('cancelled');
    });

    modal.addEventListener('cancel', function () {
        modal.close('cancelled');
    });

    // close when clicking on backdrop
    modal.addEventListener('click', function (event) {
        if (event.target === modal) {
            modal.close('cancelled');
        }
    });

});
